<template>
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.07104 7.16439L0.0537415 13.7567C0.121308 14.0072 0.242734 14.2381 0.408738 14.4319C0.574742 14.6258 0.780929 14.7773 1.01154 14.8751C1.24214 14.9728 1.49106 15.0141 1.73927 14.9958C1.98748 14.9775 2.2284 14.9001 2.44362 14.7695L9.21421 10.7372L6.07104 7.16439Z"
      fill="#EA4335"
    />
    <path
      d="M12.1555 6.04376L9.22759 4.29017L5.93198 7.3144L9.24105 10.7278L12.1466 8.99297C12.404 8.85204 12.6196 8.64012 12.77 8.38018C12.9205 8.12024 13 7.8222 13 7.51836C13 7.21453 12.9205 6.91649 12.77 6.65655C12.6196 6.39661 12.404 6.18469 12.1466 6.04376H12.1555Z"
      fill="#FBBC04"
    />
    <path
      d="M0.0538237 1.2472C0.0174503 1.38781 -0.000647665 1.5329 1.76985e-05 1.67856V13.3254C0.000381508 13.471 0.0184621 13.6159 0.0538237 13.7567L6.27738 7.33317L0.0538237 1.2472Z"
      fill="#4285F4"
    />
    <path
      d="M6.11588 7.50197L9.22766 4.29019L2.46604 0.239129C2.21167 0.083341 1.92236 0.000831709 1.62757 3.35344e-06C1.27154 -0.000734422 0.925051 0.120282 0.640912 0.344606C0.356773 0.56893 0.150572 0.884256 0.0537415 1.24252L6.11588 7.50197Z"
      fill="#34A853"
    />
  </svg>
</template>
